export const UPDATE_INPUT = 'UPDATE_INPUT';
export const UPDATE_RECEIPT_ID = 'UPDATE_RECEIPT_ID';
export const UPDATE_ADD_INPUT = 'UPDATE_ADD_INPUT';
export const UPDATE_INPUT_COMMON = 'UPDATE_INPUT_COMMON';
export const UPDATE_ADD_CONDITION = 'UPDATE_ADD_CONDITION';
export const UPDATE_ADD_INFO = 'UPDATE_ADD_INFO';
export const UPDATE_ADD_JD = 'UPDATE_ADD_JD';
export const UPDATE_ADD_CONF = 'UPDATE_ADD_CONF';
export const UPDATE_ADD_SKILL_INPUT = 'UPDATE_ADD_SKILL_INPUT';
export const UPDATE_ADD_ENVI_INPUT = 'UPDATE_ADD_ENVI_INPUT';
export const RESET_INPUT = 'RESET_INPUT';
export const RESET_INPUT_COMMON = 'RESET_INPUT_COMMON';
export const RESET_ADD_INPUT = 'RESET_ADD_INPUT';
export const CHANGE_MODIFY_MODE = 'CHANGE_MODIFY_MODE';
export const CHANGE_VALID = 'CHANGE_VALID';
export const ADD_REGISTER = 'ADD_REGISTER';
export const REGISTER = 'REGISTER';
